export const GET_POS_ROLE = "GET_POS_ROLE"
export const GET_POS_ROLE_SUCCESS = "GET_POS_ROLE_SUCCESS"

export const ADD_POS_USER = "ADD_POS_USER"
export const ADD_POS_USER_SUCCESS = "ADD_POS_USER_SUCCESS"

export const GET_POS_USER_LIST = "GET_POS_USER_LIST"
export const GET_POS_USER_LIST_SUCCESS = "GET_POS_USER_LIST_SUCCESS"

export const DELETE_POS_USER_ACTION = "DELETE_POS_USER_ACTION"
export const DELETE_POS_USER_ACTION_SUCCESS = "DELETE_POS_USER_ACTION_SUCCESS"

export const EDIT_POS_USER_ACTION = "EDIT_POS_USER_ACTION"
export const EDIT_POS_USER_ACTION_SUCCESS = "EDIT_POS_USER_ACTION_SUCCESS"

export const UPDATE_POS_USER_ACTION = "UPDATE_POS_USER_ACTION"
export const UPDATE_POS_USER_ACTION_SUCCESS = "UPDATE_POS_USER_ACTION_SUCCESS"


export const POS_USER_API_ERROR_ACTION = "POS_USER_API_ERROR_ACTION"





